import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import BlackBorder from '../../../Assets/images/DFL/landing-page-img/line-black.png'
import Slider from "react-slick";
import round from "../../../Assets/images/home/diamond-round.png";
import RoundShape from "../../../Assets/images/diamond-shape/Diamond_Round.svg";
import princess from "../../../Assets/images/diamond-shape/princess.svg";
import cushion from "../../../Assets/images/diamond-shape/cushion.svg";
import emerald from "../../../Assets/images/diamond-shape/emerald.svg";
import oval from "../../../Assets/images/diamond-shape/oval.svg";
import radiant from "../../../Assets/images/diamond-shape/radiant.svg";
import asscher from "../../../Assets/images/diamond-shape/asscher.svg";
import marquise from "../../../Assets/images/diamond-shape/marquise.svg";
import heart from "../../../Assets/images/diamond-shape/heart.svg";
import pear from "../../../Assets/images/diamond-shape/pear.svg";

import roundImg from "../../../Assets/images/home/diamond-shapes-img/Round.webp";
import princessImg from "../../../Assets/images/home/diamond-shapes-img/Princess.webp";
import cushionImg from "../../../Assets/images/home/diamond-shapes-img/Cushion.webp";
import emeraldImg from "../../../Assets/images/home/diamond-shapes-img/Emerald.webp";
import ovalImg from "../../../Assets/images/home/diamond-shapes-img/Oval.webp";
import radiantImg from "../../../Assets/images/home/diamond-shapes-img/Radiant.webp";
import asscherImg from "../../../Assets/images/home/diamond-shapes-img/Asscher.webp";
import marquiseImg from "../../../Assets/images/home/diamond-shapes-img/Marquise.webp";
import heartImg from "../../../Assets/images/home/diamond-shapes-img/Heart.webp";
import pearImg from "../../../Assets/images/home/diamond-shapes-img/Pear.webp";
import LeftArrow from '../../../Assets/images/DFL/landing-page-img/left-arrow.png'
import RightArrow from '../../../Assets/images/DFL/landing-page-img/right-arrow.png'
import { useHistory } from "react-router-dom";

const ExploreDimondByShap = () => {
    var history = useHistory();
    const shopbyshape = async (value) => {
        history.push("/diamonds/" + value);
    };

    const exploreDimondByShap = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img src={LeftArrow} />,
        nextArrow: <img src={RightArrow} />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const imageShap = [
        {
            shapImage: roundImg,
            shapName: "Round",
            shapText: "Cut with the optimum light refraction and sparkle."
        },
        {
            shapImage: princessImg,
            shapName: "Princess",
            shapText: "A contemporary cut, with optimal fire and brilliance."
        },
        {
            shapImage: cushionImg,
            shapName: "Cushion",
            shapText: "With soft corners, a beautiful alternative to a round or princess cut."
        },
        {
            shapImage: emeraldImg,
            shapName: "Emerald",
            shapText: "This stylish cut creates rectangular facets that beautifully accentuate the stone's clarity."
        },
        {
            shapImage: ovalImg,
            shapName: "Oval",
            shapText: "Optimises carat, giving the illusion of a larger stone."
        },
        {
            shapImage: radiantImg,
            shapName: "Radiant",
            shapText: "The most brilliant of the rectangular cut diamonds."
        },
        {
            shapImage: asscherImg,
            shapName: "Asscher",
            shapText: "This unique shape is a square emerald, with linear facets."
        },
        {
            shapImage: marquiseImg,
            shapName: "Marquise",
            shapText: "Elongate the finger of the wearer maintaining an appearance of great size and grandeur."
        },
        {
            shapImage: heartImg,
            shapName: "Heart",
            shapText: "A rare cut that is a true testament of your relationship."
        },
        {
            shapImage: pearImg,
            shapName: "Pear",
            shapText: "Combining the brilliance and design of the Round and Marquise cuts."
        },

    ]

    return (
        <>
            <div className='dfld_explore_diamond_by_shap_section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={12} lg={12}>
                            <div className='dfld_landing_hading_with_border'>
                                <h1 className='text-uppercase'>Wholesale Loose Diamonds for Sale </h1>
                                <Image src={BlackBorder} alt="black border image" className='dfld_black_border_img' />
                            </div>
                        </Col>
                    </Row>
                    <Row className='w-100 m-auto'>
                        <div className='dfld_shap_slider'>
                            <Slider {...exploreDimondByShap} className="dfld_explore_diamond_shap_slider">
                                {imageShap.map((val) => (
                                    <div className='dfld_img_shap_box_outer' onClick={() => shopbyshape(val.shapName)}>
                                        <div className='dfld_img_shap_box_inner'>
                                            <Image src={val.shapImage} alt={val.shapName}/>
                                            <h4>{val.shapName}</h4>
                                            <p>{val.shapText}</p>
                                        </div>
                                    </div>

                                ))}
                            </Slider>
                        </div>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default ExploreDimondByShap